import { render, staticRenderFns } from "./PublishedCanteenCard.vue?vue&type=template&id=418b2172&scoped=true&"
import script from "./PublishedCanteenCard.vue?vue&type=script&lang=js&"
export * from "./PublishedCanteenCard.vue?vue&type=script&lang=js&"
import style0 from "./PublishedCanteenCard.vue?vue&type=style&index=0&id=418b2172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418b2172",
  null
  
)

export default component.exports